import type { CellProp } from '..'

export default function PlainTextField(props: Pick<CellProp, 'value'>) {
	return <div className='cell-data-text truncate'>{props.value}</div>
}
